/* eslint-disable @typescript-eslint/no-explicit-any */
export default function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            func(...args);
        }, delay);
    };
}
//# sourceMappingURL=debounce.js.map